<template>
	<div>
		<el-row type="flex" justify="center" style="margin-top:120px;">
			<el-card class="box-card" style="width:40%">
				<div slot="header" class="clearfix">
					<span style="text-align: left;">用户注册</span>
				</div>
				<div style="padding-right: 70px;">
					<el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="100px" class="demo-ruleForm">
						<el-form-item label="账户" prop="acc">
							<el-input v-model="ruleForm.acc" placeholder="手机号"></el-input>
						</el-form-item>
						<el-form-item label="密码" prop="pwd">
							<el-input v-model="ruleForm.pwd" placeholder="密码"></el-input>
						</el-form-item>
						<el-form-item label="昵称" prop="name">
							<el-input v-model="ruleForm.name" placeholder="密码"></el-input>
						</el-form-item>
						<el-form-item style="text-align: left;">
							<el-button type="primary" :disabled="canSubmit" @click="submitForm('ruleForm')">注册
							</el-button>
						</el-form-item>
					</el-form>
				</div>
			</el-card>
		</el-row>
	</div>
</template>

<script>
	export default {
		data() {
			return {
				canSubmit: false,
				ruleForm: {
					action: 'CustRegst',
					acc: '',
					name: '',
					pwd: '',
					registerWay: 'PC'
				},
				rules: {
					name: [{
							required: true,
							message: '请输入昵称',
							trigger: 'blur'
						},
						{
							min: 3,
							max: 5,
							message: '长度在 3 到 5 个字符',
							trigger: 'blur'
						}
					],
					acc: [{
							required: true,
							message: '请输入用户名',
							trigger: 'blur'
						},
						{
							min: 11,
							max: 11,
							message: '手机号码11位',
							trigger: 'blur'
						}
					],
					pwd: [{
							required: true,
							message: '请输入密码',
							trigger: 'blur'
						},
						{
							min: 6,
							max: 10,
							message: '长度在 6 到 10 个字符',
							trigger: 'blur'
						}
					],

				}
			}
		},
		created() {

		},
		methods: {
			submitForm(formName) {
				let self = this
				self.$refs[formName].validate((valid) => {
					if (valid) {
						self.canSubmit = true
						let url = 'https://www.liligc.com/NWCenter/dlAppTest';
						self.axios.get(url, {
							params: {
								action: self.ruleForm.action,
								acc: self.ruleForm.acc,
								name: self.ruleForm.name,
								pwd: self.ruleForm.pwd,
								registerWay: self.ruleForm.registerWay
							}
						}).then((res) => {
							console.log(res)
							if (res.data.result) {
								self.$message.success(res.data.msg)
								self.$refs['ruleForm'].resetFields();
							} else {
								self.canExec = false
							}
						}).catch(function(err) {
							self.$message.error(err)
						}).finally(() => {
							self.canSubmit = false
						});
					} else {
						self.$message.error('输入信息不符合规范')
						return false;
					}
				});
			}
		}
	}
</script>

<style lang="less" scoped>
</style>
